<template>
    <div
        class="relative bg-white cursor-pointer hover:bg-slate-100 flex flex-col transition-colors"
        :class="classes"
        @click="selectDate(day.date)"
    >
        <time :datetime="day.date" :class="todayClasses">
            {{ dayLabel }}
        </time>
        <DayItems
            :events="todayEvents"
            :size="size"
            :active="isChosen"
            v-if="!isPastDate && disablePastDates"
        />
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import dayjs from 'dayjs';

import DayItems from '@/components/calendar/partials/day-items.vue';

export default {
    props: {
        size: {
            type: String,
            default: 'full', // full | mini
        },
        day: {
            type: Object,
            required: true,
        },
        disablePastDates: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        DayItems,
    },
    computed: {
        ...mapState(useCalendarStore, [
            'loading',
            'view',
            'activeDate',
            'chosenDate',
            'todayFormatted',
            'chosenDateFormatted',
            'events',
        ]),
        isToday() {
            return this.day.date === this.todayFormatted;
        },
        isPastDate() {
            return dayjs(this.day.date).isBefore(dayjs(), 'day');
        },
        isChosen() {
            return this.day.date === this.chosenDateFormatted;
        },
        dayLabel() {
            return this.day.dayLabel;
        },
        todayEvents() {
            return this.events.filter((event) => {
                return event.start_date === this.day.date;
            });
        },
        classes() {
            let classes = ' font-medium ';

            if (this.size === 'full') {
                classes +=
                    'first:border-t first:border-l first:rounded-tl-md h-[156px] text-slate-800 text-sm text-right p-2';
            }

            if (this.size === 'mini' && this.isToday) {
                classes += ' !bg-slate-100 ';
            }

            if (this.size === 'full' && this.isToday) {
                classes += ' !bg-slate-100 ';
            }

            if (this.size === 'mini' && this.isChosen) {
                classes +=
                    ' !bg-slate-800 !text-white hover:!bg-slate-600 hover:!text-white transition-all';
            }

            if (this.size === 'mini') {
                classes +=
                    ' w-12 h-12 py-1.5 leading-tight text-sm flex flex-col items-center justify-start rounded';
            }

            if (!this.day.isCurrentMonth) {
                classes += ' !text-slate-400 ';
            }

            if (this.isPastDate && this.disablePastDates) {
                classes +=
                    ' !text-slate-400 !cursor-not-allowed hover:!bg-white ';
            }

            return classes;
        },
        todayClasses() {
            const classes = this.size === 'full' ? 'font-semibold' : '';
            return this.isToday ? classes : '';
        },
    },
    methods: {
        ...mapActions(useCalendarStore, ['setChosenDate', 'setView']),
        selectDate(date) {
            if (this.isPastDate && this.disablePastDates) {
                return;
            }

            this.setChosenDate(date);
            this.setView({ label: 'Day', name: 'day' });
        },
    },
};
</script>
